var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"env-ribbon-wrapper",on:{"click":_vm.hide}},[_c('div',{staticClass:"env-ribbon"},[_c('span',{staticClass:"env-ribbon-text"},[_vm._v(_vm._s(_vm.envName))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }